// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleHeader_root__bbmSF","container":"SimpleHeader_container__gunKW","logo":"SimpleHeader_logo__7GUzB"};